/* global window */

// Export the stardard process.env (used in backend) and window.__env (used for frontend runtime configuration)
module.exports = Object.assign({}, process.env, typeof window !== 'undefined' ? window.__env : {});
